export var Position = /*#__PURE__*/function (Position) {
  Position["top"] = "top";
  Position["bottom"] = "bottom";
  Position["right"] = "right";
  Position["left"] = "left";
  return Position;
}({});